<template>
  <div class="fullwidth narex collections">
    <my-area-nav />
    <div class="collection-view">
      
      <div class="flex-images">
        <collection-group-image v-for="folder in folders" :key="folder.foldername"
          :foldername="folder.foldername" :image="folder.image" v-on:click="goFolder(folder.foldername)" />
        <div v-for="n in extraImages" :key="'xtra' + n" class="imdiv"></div>
      </div>
    </div>

  </div>
</template>

<script>
import MyAreaNav from './MyAreaNav.vue'
import apix from '@/api.js'
import CollectionGroupImage from './CollectionGroupImage.vue'
import likeUtil from '@/utils/likes.js'
import '@/css/my-area.css'

export default {
  components: {
    MyAreaNav,
    CollectionGroupImage
  },
  data () {
    return {
      folders: [],
      extraImages: 0,
      showZoom: false,
      curpos: 0,
      selImage: null,
      loaded: false
    }
  },
  created () {
    if(!this.$store.state.signedIn) {
      this.$ixr.push('/')
    }
    else {
      this.loadData()
    }
  },
  mounted () {
    window.addEventListener('resize', this.setExtraImages)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.setExtraImages)
  },
  methods: {
    
    setExtraImages () {
      let rowWidth = this.$k.getBreakpoint().columns
      let extra = this.folders.length % rowWidth
      if(extra > 0) {
        this.extraImages = rowWidth - extra
      }
    },
    goFolder(folderName) {
      this.$store.commit('setProfileFolder', folderName)
      this.$ixr.push('/my-area/collections/view')
    },
    async loadData () {
      this.loaded = false
      let likes = []
      for(let each of this.$store.state.profile.folders)
      {
        let arr = likeUtil.stringToNumberArray(each.image_ids)
        if(arr.length > 0) {
          likes.push(arr[0])
        }
      }
      let image_ids = likes.filter((item, pos) => likes.indexOf(item) === pos)
      let res = await apix.post('collections/images', { image_ids: image_ids })
      let images = res.data
      console.log('got images', images)
      let fds = []
      for(let folder of this.$store.state.profile.folders) {
        let fd = { foldername: folder.name }
        let arr = likeUtil.stringToNumberArray(folder.image_ids)
        if(arr.length > 0) {
          let image = images.find(el => el.image_id === arr[0])
          fd.image = image
        }
        fds.push(fd)
        
      }
      this.folders = fds
      this.setExtraImages()
      this.currentPos = 0
      this.loaded = true
    }
  },
  watch: {
    '$store.state.signedIn': function () {
      if(!this.$store.state.signedIn) {
        this.$ixr.push('/')
      }
    },
    '$store.state.profileFolder': function () {
      this.loadData()
    }
  }
}
</script>

<style>

</style>